import { StarBorder } from '@mui/icons-material';
import { IconButton, Stack, Tab, Tabs, Tooltip } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { SupplierItemCalculation } from '@retail/my-assortment/types';
import { EditButtonIcon } from '@shared/custom-icons';
import { blockTab } from '@shared/styles';
import { alphabeticSort } from '@shared/utils';
import { useMemo } from 'react';

interface Props {
  supplierItems: Partial<SupplierItemCalculation>[];
  currentMgSupplierItemId?: number;
  updateSelectedSupplierItem: (mgSupplierItemId: number) => void;
  openPrioModal: () => void;
}
const blockTabs = blockTab;

export function SupplierSelectTabs({
  supplierItems,
  currentMgSupplierItemId,
  updateSelectedSupplierItem,
  openPrioModal,
}: Props) {
  const t = useMyAssortmentTFunction();

  const tabs = useMemo(() => {
    const sortedSuppliersByPriority = supplierItems
      .filter(({ inAssortment }) => !!inAssortment)
      .sort(alphabeticSort<Partial<SupplierItemCalculation>>('supplierName'));

    return sortedSuppliersByPriority.map(({ supplierName, mgSupplierItemId, prioritised }) => ({
      label: prioritised ? (
        <Stack alignItems="baseline" flexDirection="row">
          {supplierName}
          <Tooltip title={t('myAssortment.priority.mainPrioSupplier')} placement="top" arrow>
            <StarBorder color="success" fontSize="small" />
          </Tooltip>
        </Stack>
      ) : (
        supplierName
      ),
      value: mgSupplierItemId,
    }));
  }, [supplierItems, t]);

  const unprioritizedTab = supplierItems.filter((supplierItem) => !supplierItem.inAssortment);

  return (
    <Stack
      mt={1}
      bgcolor="grey.50"
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      pr={1}
    >
      <Tabs
        value={currentMgSupplierItemId}
        variant="scrollable"
        scrollButtons={false}
        onChange={(_, newTab) => updateSelectedSupplierItem(newTab)}
      >
        {tabs.map(({ label, value }) => (
          <Tab
            className={blockTabs}
            key={value}
            sx={{ background: 'inherit' }}
            label={label}
            value={value}
          />
        ))}
        {unprioritizedTab.map(({ mgSupplierItemId, supplierName }) => (
          <Tab
            key={mgSupplierItemId}
            sx={{ background: 'inherit' }}
            label={supplierName}
            value={mgSupplierItemId}
            disabled
          />
        ))}
      </Tabs>
      <Tooltip title={t('myAssortment.priority.editPriority')} placement="top" arrow>
        <IconButton onClick={openPrioModal}>
          <EditButtonIcon />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
